<template>
  <div id="app">
    <div class="container">
      <div class="columns">
        <div class="column col-8 col-mx-auto">

          <div class="input-group input-inline">
            <input class="form-input" type="text" placeholder="42" v-model="in_dig">&nbsp;
          </div>

          <div class="input-group input-inline">
            <select class="form-select" v-model="sx">
              <option :value="0">М</option>
              <option :value="1">Ж</option>
              <option :value="2">С</option>
            </select>&nbsp;
          </div>

          <div class="input-group input-inline">
            <select class="form-select" v-model="xcase">
              <option :value="0">Именительный</option>
              <option :value="1">Родительный</option>
              <option :value="2">Дательный</option>
              <option :value="3">Винительный</option>
              <option :value="4">Творительный</option>
              <option :value="5">Предложный</option>
            </select>&nbsp;
          </div>

        </div>
      </div>

      <div class="columns">
        <div class="column col-8 col-mx-auto">&nbsp;</div>
        <div class="column col-8 col-mx-auto">
          <div class="toast" v-bind:class="{ 'toast-error': has_error }" v-if="in_word">
              {{ in_word }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import axios from 'axios';

export default {
  data() {
    return {
      sx: 0,
      xcase: 0,
      in_word: "",
      in_dig: "",
      has_error: true
    }
  },
  mounted () {
    this.convert()
  },
  watch: {
    in_dig: function() {
      this.convert()
    },
    sx: function() {
      this.convert()
    },
    xcase: function() {
      this.convert()
    }
  },
  methods: {
    convert: function() {
      var th = this;
      axios.get('/api/' + th.in_dig, {
          params: {
            sx: th.sx,
            case: th.xcase
          }
        })
        .then(function (response) {
          console.log(response.data.text);
          th.in_word = response.data.text
          th.has_error = false
        })
        .catch(function (error) {
          console.log(error.response);
          if (!error.response) {
            th.in_word = "Сервер недоступен"
          }
          else if (error.response.status == 400) {
            th.in_word = error.response.data.text
            th.has_error = true
          }
          else {
            th.in_word = "Ошибка сервера"
            th.has_error = true
          }

        })
        .then(function () {
        });  
    }
  }

}
</script>

<style scoped>

</style>
